import React from "react";
import { motion } from "framer-motion";
import logoImg from "../../assets/logo.png";

export default function ReferFriend() {
  return (
    <div
      style={{
        backgroundColor: "#f9fafb",
        minHeight: "100vh",
        paddingTop: "150px",
		
        padding: "20px",
      }}
    >
      <div
        style={{
          maxWidth: "800px",
          margin: "40px auto",
          backgroundColor: "white",
          borderRadius: "20px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          padding: "30px",
          textAlign: "center",
        }}
      >
        <div
			  style={{
				width: 62,
				height: 62,
				borderRadius: "50%",
				border: "2px solid #9ca3af", // 👈 wider border
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				backgroundColor: "#fff",
				boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
				marginRight: 12,
			  }}
			>
			  <img
				src={logoImg}
				alt="Convalesce Logo"
				style={{
				  width: 40,
				  height: 40,
				  borderRadius: "50%",
				}}
			  />
			</div>

        <h1
          style={{
            fontSize: "18px",
            fontWeight: "600",
            color: "gray",
            marginBottom: "10px",
          }}
        >
          Refer a Friend
        </h1>

        <p style={{ fontSize: "14px", color: "#6b7280" }}>
          Soon you’ll be able to refer friends and colleagues directly from your
          app and earn rewards for every successful placement!
        </p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          style={{
            marginTop: "30px",
            backgroundColor: "#f3f4f6",
            borderRadius: "12px",
            padding: "20px",
            color: "#9ca3af",
          }}
        >
          <p style={{ fontSize: "14px" }}>
            🚧 This page is under construction.
            <br />
            Coming soon — stay tuned!
          </p>
        </motion.div>
      </div>

      <div
        style={{
          textAlign: "center",
          color: "#9ca3af",
          marginTop: "40px",
          fontSize: "13px",
        }}
      >
        
      </div>
    </div>
  );
}
